import { AfterViewInit, Component, ViewChild, signal, inject, OnInit } from '@angular/core';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AdInitiateDialog } from '../ad-initiate/ad-initiate.dialog';
import { AdService } from '../ad-service/ad-service';
import { AdDashboard, advisorListing, declarationData } from '../ad-interface/ad-dashboard.interface';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';

@Component({
  selector: 'app-ad-dasboard',
  imports: [
    PiasLayoutComponent,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTableModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatMenuModule,
    MatDividerModule,
    MatBadgeModule,
    MatChipsModule,
    MatSelectModule
  ],
  templateUrl: './ad-dasboard.component.html',
  styleUrl: './ad-dasboard.component.scss'
})
export class AdDasboardComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  searchQueryFg!: FormGroup;
  searchQuery = '';
  selectedStatus = '';
  selectedChanges = '';
  uniqueStatuses: string[] = [];
  private formBuilder = inject(FormBuilder);
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private adservice = inject(AdService);
  private snackmessage = inject(SnackbarService);
  protected contactsDs = new MatTableDataSource<any>();
  public applicants!: advisorListing[];

  totalCount = 0;
  notstartedcount = 0;
  inprogresscount = 0;
  submittedCount = 0;
  retuenedcount = 0;
  inreviewcount = 0;
  approvedcount = 0;
  public pagedApplicants = this.applicants;
  displayedColumns: string[] = [
    'repname',
    'branch',
    'startDate',
    'endDate',
    'changes',
    'status',
    'actions'
  ];
  setSprinner = signal(false);

  protected _onSearchRecipients(event: Event): void {
    const searchValue = (event.target as HTMLInputElement).value;
    this.searchQuery = searchValue;
    this.applyFilters();
  }

  protected _clearRecipientSearch(): void {
    this.searchQuery = '';
    this.contactsDs.filter = '';
    this.applyFilters();
  }

  protected extractUniqueStatuses(): void {
    const statuses = new Set<string>();
    this.applicants.forEach(applicant => {
      statuses.add(applicant.userAnndeclarestatus);
    });
    this.uniqueStatuses = Array.from(statuses).sort();
  }

  protected clickFilters(status: string) {
    this.selectedStatus = status;
    this.applyFilters();
  }

  async applyFilters() {
    let filtered = this.applicants;

    // Apply status filter
    if (this.selectedStatus) {
      filtered = filtered.filter(applicant =>
        applicant.userAnndeclarestatus === this.selectedStatus
      );
    }

    if (this.selectedChanges) {
      filtered = filtered.filter(applicant => {
        const changeCount = applicant.diferencecount || 0;
        const yesCount = applicant.truecount || 0;

        switch (this.selectedChanges) {
          case '1': // No Changes
            return changeCount === 0 && yesCount === 0;

          case '2': // No Changes (Y)
            return changeCount === 0 && yesCount > 0;

          case '3': // Changes
            return changeCount > 0;

          default:
            return true;
        }
      });
    }

    this.contactsDs.data = filtered;

    // Apply search filter if there's a search query
    if (this.searchQuery.trim()) {
      this.contactsDs.filter = this.searchQuery.trim().toLowerCase();
    }
    const filter = {
      selectedStatus: this.selectedStatus,
      selectedChanges: this.selectedChanges
    };
    sessionStorage.setItem('filter', JSON.stringify(filter));
  }

  protected onStatusFilterChange(): void {
    this.applyFilters();
  }

  protected onChangesFilterChange(): void {
    this.applyFilters();
  }

  public declarationData!: declarationData;
  async loadDeclarationData() {
    this.setSprinner.set(true);
    const responseData = await this.adservice.getdeclaration()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // Handle error
        console.error('Error fetching declarations:', error.message);
      });
    this.setSprinner.set(false);
    this.declarationData = responseData.data.responsedata;
  }
  public dashboardData!: AdDashboard;
  // protected contactsDs = new MatTableDataSource<any>();

  async loadDashboardData() {
    this.setSprinner.set(true);
    const responseData = await this.adservice.getdashboard()
      .then((response) => {
        return JSON.parse(response);

      })
      .catch((error) => {
        console.error('Error fetching dashboard data:', error.message);
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      this.dashboardData = responseData.data.responsedata;

      // Now TypeScript won't complain about the property access
      if (this.dashboardData && this.dashboardData.advisorListing) {

        this.contactsDs.data = this.dashboardData.advisorListing;
        this.applicants = this.dashboardData.advisorListing;
        this.totalCount = this.dashboardData.totalAdvisorCount;
        this.notstartedcount = this.dashboardData.categoryData.find(x => x.anndeclareStatus == 'Not_Started')?.cnt || 0;
        this.inprogresscount = this.dashboardData.categoryData.find(x => x.anndeclareStatus == 'In_progress')?.cnt || 0;
        this.submittedCount = this.dashboardData.categoryData.find(x => x.anndeclareStatus == 'Submitted')?.cnt || 0;
        this.retuenedcount = this.dashboardData.categoryData.find(x => x.anndeclareStatus == 'Returned')?.cnt || 0;
        this.inreviewcount = this.dashboardData.categoryData.find(x => x.anndeclareStatus == 'In_Review')?.cnt || 0;
        this.approvedcount = this.dashboardData.categoryData.find(x => x.anndeclareStatus == 'Approved')?.cnt || 0;
        this.extractUniqueStatuses();
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackmessage.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackmessage.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async ngOnInit(): Promise<void> {
    await this.loadDeclarationData();
    await this.loadDashboardData();
    this.searchQueryFg = this.formBuilder.group({
      searchApplicants: [''],

    });

    const filterString = sessionStorage.getItem('filter');
    const filter = filterString ? JSON.parse(filterString) : null;

    if (filter) {
      this.selectedStatus = filter.selectedStatus;
      this.selectedChanges = filter.selectedChanges;
      await this.applyFilters();
    }
  }

  ngAfterViewInit(): void {
    this.contactsDs.paginator = this.paginator;
  }

  updatePagedData(): void {
  }

  goToView(applicant: any): void {

    this.router.navigate(
      ['annual-declaration/dsu-annual-declaration-form'],
      {
        state: {
          uadsId: applicant.uadsId,
          mode: 'view',
          workflowstatus: applicant.userAnndeclarestatus
        }
      }
    );

  }
  goToReview(applicant: any): void {

    this.router.navigate(
      ['annual-declaration/dsu-annual-declaration-form'],
      {
        state: {
          uadsId: applicant.uadsId,
          mode: 'review',
          workflowstatus: applicant.userAnndeclarestatus
        }
      }
    );

  }
  public openInitiateDialog(): void {

    const dialogRef = this.dialog.open(AdInitiateDialog, {
      width: '600px',

      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.loadDeclarationData();
      }

    });
  }

  canView(status: string): boolean {
    return [
      'Approved',
      'Returned',
      'Submitted',
      'In_Review'
    ].includes(status);
  }

  canReview(status: string): boolean {

    return [
      'Submitted',
      'In_Review'
    ].includes(status);

  }

  getStatusClass(status: string): string {
    if (!status) return 'submitted'; // Safe fallback if status is null/undefined

    switch (status.trim()) {
      case 'NOT STARTED':
        return 'status-notstated';

      case 'IN PROGRESS':
        return 'status-In_progress';

      case 'SUBMITTED':
        return 'status-Submitted';
      case 'RETURNED':
        return 'status-Returned';
      case 'IN REVIEW':
        return 'status-In_Review';

      case 'APPROVED':
        return 'status-Approved';
      default:
        return 'status-Submitted'; // Default fallback style for unrecognized statuses
    }
  }

}
